<template>
    <div id="mainWrapper" class="col-12 d-flex flex-column align-items-center pb-5">
        <div class="styleNames col-12 col-md-8 d-flex justify-content-around mb-4">
            <div v-for="(style, index) in this.dataArray" :key="index" @click="styleSelected = style.name">
                <div class="text-light cursorPointer"
                    :class="styleSelected === style.name ? 'selectedTextStyle' : 'textStyle'">
                    {{ style.name }}
                </div>
            </div>
        </div>
        <div class="styleImages col-12">
            <template v-for="(style, index) in this.dataArray">
                <template v-if="style.name === styleSelected">
                    <template v-for="(image, index) in style.images">
                        <div class="imageWrapper">
                            <img class="aiImage" :src="image" />
                        </div>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AiStyleSwitcher',
    data() {
        return {
            styleSelected: this.dataArray[0].name,
        };
    },
    props: {
        dataArray: {
            type: Array,
            default: [
                {
                    name: 'Realistic',
                    images: [
                        require(`../../../../../../img/ai_images/realistic/realistic_01.jpg`),
                        require(`../../../../../../img/ai_images/realistic/realistic_02.jpg`),
                        require(`../../../../../../img/ai_images/realistic/realistic_03.jpg`),
                        require(`../../../../../../img/ai_images/realistic/realistic_04.jpg`),
                        require(`../../../../../../img/ai_images/realistic/realistic_05.jpg`),
                        require(`../../../../../../img/ai_images/realistic/realistic_06.jpg`),
                    ],
                },
                {
                    name: 'Anime',
                    images: [
                        require(`../../../../../../img/ai_images/anime/anime_01.jpg`),
                        require(`../../../../../../img/ai_images/anime/anime_02.jpg`),
                        require(`../../../../../../img/ai_images/anime/anime_03.jpg`),
                        require(`../../../../../../img/ai_images/anime/anime_04.jpg`),
                        require(`../../../../../../img/ai_images/anime/anime_05.jpg`),
                        require(`../../../../../../img/ai_images/anime/anime_06.jpg`),
                    ],
                },
                {
                    name: 'Artistic',
                    images: [
                        require(`../../../../../../img/ai_images/artistic/art_01.jpg`),
                        require(`../../../../../../img/ai_images/artistic/art_02.jpg`),
                        require(`../../../../../../img/ai_images/artistic/art_03.jpg`),
                        require(`../../../../../../img/ai_images/artistic/art_04.jpg`),
                        require(`../../../../../../img/ai_images/artistic/art_05.jpg`),
                        require(`../../../../../../img/ai_images/artistic/art_06.jpg`),
                    ],
                },
                // {
                //     name: 'Fantasy',
                //     images: [
                //         require(`../../../../../../img/ai_images/realistic/01.png`),
                //         require(`../../../../../../img/ai_images/realistic/02.png`),
                //         require(`../../../../../../img/ai_images/realistic/03.png`),
                //         require(`../../../../../../img/ai_images/realistic/04.png`),
                //         require(`../../../../../../img/ai_images/realistic/05.png`),
                //         require(`../../../../../../img/ai_images/realistic/06.png`),
                //     ],
                // },
                // {
                //     name: 'SciFi',
                //     images: [
                //         require(`../../../../../../img/ai_images/scifi/01.png`),
                //         require(`../../../../../../img/ai_images/scifi/02.png`),
                //         require(`../../../../../../img/ai_images/scifi/03.png`),
                //         require(`../../../../../../img/ai_images/scifi/04.png`),
                //         require(`../../../../../../img/ai_images/scifi/05.png`),
                //         require(`../../../../../../img/ai_images/scifi/06.png`),
                //     ],
                // },
            ],
        },
    },
};
</script>
<style scoped>
.styleImages {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(157px, max-content));
    grid-gap: 16px;
    justify-content: center;
    padding: 10px 0;
}

.styleNames {
    overflow-x: scroll;
    width: 100%;
}

.styleNames::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.textStyle {
    padding: 10px 20px 10px 20px;
    border-radius: 9px;
}

.selectedTextStyle {
    border: 1px solid #e8eaed;
    padding: 10px 20px 10px 20px;
    border-radius: 9px;
}

.cursorPointer {
    cursor: pointer;
}

.imageWrapper {
    width: 157px;
    height: 178px;
}

.aiImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 9px;
    border: 1px solid #666666;
}
</style>
